import cn from 'classnames'

import { useEffect } from 'react'

import { useAppDispatch, useAppSelector } from '../../../store/hooks'

import { getCurrencies, fetchCurrencies } from '../../../store/reducers/currencies'

import styles from './styles.module.scss'
import Step1Icon from './icons/step1.svg'
import Step2Icon from './icons/step2.svg'
import Step3Icon from './icons/step3.svg'

import Step1Img from './images/step1Illustration.svg'
import Step2Img from './images/step2Illustration.svg'
import Step3Img from './images/step3Illustratiom.svg'
import StartNow from './start-now'
import { useTranslation } from 'utils/use-translation'

export default function HowToExchange() {
  const { t } = useTranslation()
  
  const dispatch = useAppDispatch()
  const currencies = useAppSelector(getCurrencies)

  useEffect(() => {
    if (!currencies.length) {
      dispatch(fetchCurrencies(true))
    }
  }, [dispatch])
  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.wrapper__item}>
          <img className={styles.wrapper__item__number} src={Step1Icon} alt="number 1" />
          <img
            className={cn(styles.wrapper__item__bg, styles.wrapper__item__bg_first)}
            src={Step1Img}
            alt="background"
          />
          <h3>{t('create_free_account')}</h3>
          <p>{t('you_can_trade')}</p>
        </div>

        <div className={styles.wrapper__item}>
          <img className={styles.wrapper__item__number} src={Step2Icon} alt="number 2" />
          <img className={styles.wrapper__item__bg} src={Step2Img} alt="background" />
          <h3>{t('deposit_crypto')}</h3>
          <p>{t('choose_currency')} 🎉</p>
        </div>

        <div className={styles.wrapper__item}>
          <img className={styles.wrapper__item__number} src={Step3Icon} alt="number 3" />
          <img className={styles.wrapper__item__bg} src={Step3Img} alt="background" />
          <h3>{t('exchange_cryptocurrencies')}</h3>
          <p>
            {t('choose_from')} {currencies?.filter((el) => el?.is_allowed_for_wallet)?.length}+ {t('cryptocurrencies_to_trade')}
          </p>
        </div>
      </div>

      <StartNow />
    </>
  )
}
